import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import InsightsIcon from '@mui/icons-material/Insights';
import { Link as RouterLink } from 'react-router-dom';
import { usePatientNutritionNotifications } from '../../hooks/usePatientNutritionNotifications';

export const TodayTasksWidget = () => {
  const {
    notifications,
    pendingQuestionCount,
    unreadInsightCount,
  } = usePatientNutritionNotifications();

  const nextNotification = notifications[0];
  const primaryActionHref = nextNotification?.href ?? '/patient/questions';
  const primaryActionLabel = nextNotification?.actionLabel ?? 'Open Questions';

  return (
    <Paper sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <NotificationsActiveIcon color="primary" />
            Today's Tasks
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Review nutrition team updates before you complete today&apos;s check-in.
          </Typography>
        </Box>

        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Chip
            icon={<QuestionAnswerIcon />}
            label={`${pendingQuestionCount} question${pendingQuestionCount === 1 ? '' : 's'} waiting`}
            color={pendingQuestionCount > 0 ? 'warning' : 'default'}
            variant={pendingQuestionCount > 0 ? 'filled' : 'outlined'}
          />
          <Chip
            icon={<InsightsIcon />}
            label={`${unreadInsightCount} new insight${unreadInsightCount === 1 ? '' : 's'}`}
            color={unreadInsightCount > 0 ? 'info' : 'default'}
            variant={unreadInsightCount > 0 ? 'filled' : 'outlined'}
          />
        </Stack>

        {nextNotification ? (
          <Box
            sx={{
              border: (theme) => `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              p: 2,
            }}
          >
            <Typography variant="subtitle2" gutterBottom>
              Next up
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {nextNotification.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {nextNotification.message}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No outstanding nutrition team tasks right now.
          </Typography>
        )}

        <Box>
          <Button component={RouterLink} to={primaryActionHref} variant="contained">
            {primaryActionLabel}
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};
